import { takeEvery, call, put } from "redux-saga/effects";
import {
  ENGINEER_EMAIL_DELETE_REQUEST,
  engineerEmailDeleted,
  engineerEmailDeleteError,
} from "../../actions/engineers";
import deleteEmail from "../../../../../backend/oncall/partners/engineers/emails/remove";

const requestDeleteEmail = function*(action) {
  try {
    yield call(deleteEmail, action.payload.engineerId, action.payload.email);
    yield put(engineerEmailDeleted(action.payload.email));
  } catch (ignore) {
    yield put(engineerEmailDeleteError(action.payload.email));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeEvery(ENGINEER_EMAIL_DELETE_REQUEST, requestDeleteEmail);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/engineers/request-delete-email.js